import IconListBulleted from '@/shared/icons/NewDesign/IconListBulleted'
import useContractsCard from './useContractsCard'
import ColumnHeader from './ColumnHeader/ColumnHeader'
import ContractsBody from './ContractsBody/ContractsBody'
import ContractsPager from './ContractsPager/ContractsPager'
import { OverviewCard } from '../styled-components'
import {
  BandTitle,
  BottomPager,
  ContractsBand,
  ContractsHeaderRow,
  ContractsTable,
  HeaderCell,
} from './styled-components'

const TITLE_ID = 'overview-contracts-title'

interface ContractsCardProps {
  businessType: string
  getContracts: () => void
  formInitUrl: string
  canReset: boolean
  onReset: () => void
}

const ContractsCard = ({ businessType, getContracts, formInitUrl, canReset, onReset }: ContractsCardProps) => {
  const { title, actionsLabel, columns, contracts, bodyState, pager, showBottomPager, onRetry } = useContractsCard({
    businessType,
    getContracts,
  })

  return (
    <OverviewCard aria-labelledby={TITLE_ID}>
      <ContractsBand>
        <BandTitle id={TITLE_ID}>
          <IconListBulleted size={18} />
          {title}
        </BandTitle>
        <ContractsPager {...pager} />
      </ContractsBand>
      <ContractsTable role='table' aria-labelledby={TITLE_ID}>
        <ContractsHeaderRow role='row'>
          {columns.map(column => (
            <ColumnHeader key={column.key} label={column.label} direction={column.direction} onSort={column.onSort} />
          ))}
          <HeaderCell role='columnheader'>{actionsLabel}</HeaderCell>
        </ContractsHeaderRow>
        <ContractsBody
          state={bodyState}
          contracts={contracts}
          getContracts={getContracts}
          formInitUrl={formInitUrl}
          onRetry={onRetry}
          canReset={canReset}
          onReset={onReset}
        />
      </ContractsTable>
      <BottomPager $hidden={!showBottomPager}>
        <ContractsPager {...pager} />
      </BottomPager>
    </OverviewCard>
  )
}

export default ContractsCard
